import type { StatusColor } from '@uiKit/components/StatusBadge.vue'

// Map of admin-service `kyc_submissions.kyc_status` values to a
// StatusBadge color. The endpoint emits any string from kyc_submissions
// (approved / pending / rejected / etc.) — unknown values fall through
// to neutral.
const KYC_STATUS_COLOR: Record<string, StatusColor> = {
  approved: 'success',
  verified: 'success',
  pending: 'warning',
  in_review: 'warning',
  resubmission_required: 'warning',
  rejected: 'danger',
  expired: 'neutral',
}

export function getKycStatusColor(status: string | null): StatusColor {
  if (!status) return 'neutral'
  return KYC_STATUS_COLOR[status] ?? 'neutral'
}

export const KYC_STATUS_OPTIONS = [
  { label: 'Approved', value: 'approved' },
  { label: 'Pending', value: 'pending' },
  { label: 'In review', value: 'in_review' },
  { label: 'Resubmission required', value: 'resubmission_required' },
  { label: 'Rejected', value: 'rejected' },
  { label: 'Expired', value: 'expired' },
] as const
